module.exports = __webpack_public_path__ + "img/goods7_2.62b13b34.jpg";